import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { buildVerticalPath, getVerticalAppStyles, type VerticalType } from '../../config/vertical';

interface LandingFinalCtaSectionProps {
  vertical: VerticalType;
  finalCtaBg: string;
  unitLabel: string;
  domainLabel: string;
}

const LandingFinalCtaSection: React.FC<LandingFinalCtaSectionProps> = ({
  vertical,
  finalCtaBg,
  unitLabel,
  domainLabel,
}) => {
  const appStyles = getVerticalAppStyles(vertical);
  return (
    <section className={finalCtaBg}>
      <div className="max-w-4xl mx-auto text-center py-14 px-4 sm:py-16 sm:px-6 lg:px-8">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-vineyard-white mb-4">
          Start managing your {domainLabel} by {unitLabel}, not by guesswork.
        </h2>
        <p className="text-lg text-vineyard-white text-opacity-90 mb-8 max-w-2xl mx-auto">
          See labor costs, track compliance, and monitor field conditions — all organized by {unitLabel} so you know exactly what is working.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link to={buildVerticalPath(vertical, '/signup')} className={`${appStyles.ctaPrimary} w-full sm:w-auto text-lg font-medium`}>
            Get Started
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
          <Link to={buildVerticalPath(vertical, '/login')} className={`${appStyles.ctaSecondary} w-full sm:w-auto text-lg font-medium`}>
            Sign in
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LandingFinalCtaSection;
